import * as types from './mutation-types';

export default {
  [types.SET_CLASS_TRIB_IBS_CBS_COLLECTION](state, payload) {
    state.classTribIBSCBSCollection = payload;
  },
  [types.SET_CST_IBS_CBS_COLLECTION](state, payload) {
    state.CSTIBSCBSCollection = payload;
  },
  [types.SET_CLASS_TRIB_IS_COLLECTION](state, payload) {
    state.classTribISCollection = payload;
  },
  [types.SET_CST_IS_COLLECTION](state, payload) {
    state.CSTISCollection = payload;
  },
  [types.SET_COD_CRED_PRES_COLLECTION](state, payload) {
    state.codCredPresCollection = payload;
  },
};
